export enum PointsOfInterestQueryParamKey {
  NAME = 'name',
}
